import type { DialogProps } from '@mui/material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';
import { CloseIcon } from '../../icons';

type VyDialog2Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
} & DialogProps;

/**
 * @deprecated Do not use this one instead use VyDialog
 */
export const VyDialog2: FC<VyDialog2Props> = ({ open, onClose, title, children, ...props }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: '22px',
        boxShadow: '0px 4px 9px 0px rgba(0, 0, 0, 0.14)',
        padding: '32px',
        gap: '22px',
      }}
      {...props}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: 400
            }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
